// React imports.
import React, { Component } from "react";
//library imports
import Highcharts from 'highcharts';
import exporting from 'highcharts/modules/exporting'; 
import offlineExporting from 'highcharts/modules/offline-exporting';
import HighchartsReact from 'highcharts-react-official';

// Initialize the exporting module
exporting(Highcharts);
offlineExporting(Highcharts);


// App imports.

import { IHighChartsDataseries, formatLabelNumber } from "../utility";

const ChartLine = ({title, subTitle, dataSeries, xAxisCategoryLabels, formatFunction}) => {

  let toolTipParamObject = function () {
    return '<b>' + this.key + '</b><br/><span style="color:'
      + this.series.color + '">' + this.series.name + '</span>: '
      + this.point.displayVal + '<br/>';
  };

  const yAxisObjectArray = [{
        labels: {
          formatter: formatFunction,
          style: {
            color: '#000'
          }
        },
        gridLineColor: '#555',
        title: {
          text: ' ',
          style: {
            color: Highcharts.getOptions().colors[0]
          }
        },
        min: 0
      }];


  let options = {
    exporting: {
      buttons: {
          contextButton: {
              menuItems: ['downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG']
          }
      }
    },
      credits: {
      enabled: false
    },
    chart: {
      height: 600,
      type: 'line',
    },
    title: {
      text: title
    },
    subtitle: {
      text: subTitle
    },
    legend: { layout: 'vertical' },
    xAxis: {
      labels: {
        enabled: true,
      },
      categories: xAxisCategoryLabels,
      crosshair: true
    },
    yAxis: yAxisObjectArray,
    series: dataSeries,
    tooltip: {
        formatter: toolTipParamObject,
        shared: false
    },
    plotOptions: {
      series:
      {
        dataLabels: {
          enabled: true,
          formatter: function () {
            return formatLabelNumber(this.y, true, this.point.prefix, this.point.suffix);
          },
          style: {
            textShadow: ''
          }
        }
      },
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    }
 
  };
  return (
    <HighchartsReact highcharts={Highcharts} options={options} />
  );
}
export default ChartLine;
